module.exports = __webpack_public_path__ + "img/icon41.7cd538df.png";